import { DefaultPageHeader, FitContentPageLayout } from 'layouts';
import type { ReactNode } from 'react';

type P = {
  children: ReactNode;
};

const ChatPageLayout = ({ children }: P) => (
  <FitContentPageLayout cardProperties={{ shrinked: true }} header={<DefaultPageHeader title="Messages" />}>
    {children}
  </FitContentPageLayout>
);

export default ChatPageLayout;
